<template>
    <div class="returns_landing">
        <header id="header" role="banner">
            <div class="container pa-3">
                <div class="header">
                    <a href="/" class="logo" aria-label="Grow With Stocks home"><img src="../assets/gws-logo-new.png" alt="Grow With Stocks"></a>
                    <p class="header_text mb-0">ACT NOW ! This could be the game changer your portfolio needs </p>
                    <a class="nav_btn" href="#contact">Join us</a>
                </div>
            </div>
        </header>
        <main id="main-content" tabindex="-1">
        <h6 class="text-center risk px-3 text-caption">Investment in securities market are subject to market risks. Read all the related documents carefully before investing</h6>
        <section class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1 col-sm-12">
                        <h1>KNOWLEDGE IS POWER: EDUCATE YOURSELF AND TAP RETURNS OF 300% - 500%!</h1>
                        <p>
                            Investing in unconventional fundamentally strong growth stocks could help you beat the market and build wealth.
                        </p>
                        <br>
                        <p>
                            We can say that with confidence because, <strong> GROW WITH STOCKS </strong> has produced these kinds of winners over the past decade.
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="stocks">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2 col-sm-12">
                        <h2>Some of our winners include</h2>
                        <div class="stock_card" v-for="stock in stocks" :key="stock.slug">
                            <div class="row">
                                <div class="col-md-2 col-sm-12">
                                   <img :src="require(`../assets/${stock.slug}-logo.png`)" :alt="`${stock.name} company logo`" class="img-thumbnail img-logo">
                                </div>
                                <div class="col-md-10 col-sm-12">
                                    <h3>{{ stock.name }}</h3>
                                </div>
                            </div>
                            <img :src="getImgUrl(stock.slug)" alt="" class="img-responsive">
                        </div>
                         <p class="text-disclaimer mb-1">
                            *Disclaimer: "The securities quoted are for illustration only and are not recommendatory"
                        </p>
                        <p class="text-disclaimer mb-4">*Note: The past performance is not an indicator of future performance.</p>
                    </div>
                </div>
            </div>
        </section>
        <section class="recommendations">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12"> 
                        <h2>
                            Well-Researched, Underrated Stocks with Solid Fundamentals Can Unleash Explosive Growth!
                        </h2>
                        <!-- <h2>
                            Our recommendation <span> Max Ventures </span> is now up by  <span>50%</span> in a month and <span> 110% </span> over the last <span> 3 </span> months.
                        </h2> -->

                        <h4>
                            For example, <span> Max Ventures </span>,  a perfect illustration . In just one month, its value shot up by a remarkable <span> 50% </span>. And over the last three months, it skyrocketed an incredible <span> 110% </span>.
                        </h4>
                        <p class="text-disclaimer mb-1">*The securities quoted are for illustration only and are not recommendatory</p>
                        <div class="row">
                            <div class="col-md-6 col-sm-12">
                                <p>
                                    High-quality stocks offer investors a generational wealth-building opportunity.
                                </p>
                                <p>
                                    It starts with understanding the stock market which can fluctuate in the short term but history proves that the stock market's value rises and makes money for investors.
                                </p>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <img src="../assets/recommendation.png" alt="Max Ventures stock recommendation showing 50% one-month and 110% three-month gain" class="">
                                <p class="text-disclaimer"> 
                                    *Disclaimer: "The securities quoted are for illustration only and are not recommendatory"
                                </br>
                                    *Note: The past performance is not an indicator of future performance.
                                </p>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
        </section>
        <section class="features">
            <div class="container">
                <div>
                    <p class="feature_text mb-0">
                        We believe that <strong> Consistency, Guidance </strong> and <strong> Updates </strong> makes a great investor, not stock ideas or tips.
                    </p>
                    <p class="feature_text">We offer Recommended Stocks Advisory reports.</p>
                </div>
                <h3>
                    Some of our key features include
                </h3>
                <div class="feature_grid">
                    <div class="feature_card" v-for="(feat, index) in features" :key="index">
                        <div class="number">
                            {{ index + 1 }}
                        </div>
                        <div>
                            <h4>{{ feat.title }}</h4>
                            <p>{{ feat.description }}</p>
                            <p class="note">{{ feat.note }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="testimonial_hero">
            <div class="container">
                <h2>kind words from our awesome subscriber base</h2>
                <div class="row">
                    <div class="col-md-5 col-md-offset-1 col-sm-12">
                        <img src="../assets/hardik.png" alt="Photo of Hardik Patwa, Grow With Stocks subscriber from Mumbai" class="img-responsive">
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <p class="testimonial_text">
                            Grow With Stocks find hidden gems at very attractive price. Their recommendations are based on plain business fundamentals and they do not encourage trading. They believe in Investment philosophy with a horizon of at least 1-2 years. I recommend GWS to everyone who would like to become a better investor and make money in the stock market.
                        </p>
                        <p class="testimonial_by">
                            <strong>
                                Hardik Patwa, Mumbai
                            </strong>
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="testimonials">
            <div class="conatiner">
                <div class="row">
                    <div class="col-md-6 col-md-offset-3 col-sm-12">
                        <div class="testimonial_card">
                            <div class="row">
                                <div class="col-md-2">
                                    <img src="../assets/gws_jay.jpg" alt="Photo of Jay Shah, Grow With Stocks subscriber" class="img-responsive">
                                    <h5>Jay Shah</h5>
                                </div>
                                <div class="col-md-10">
                                    <p>
                                        I Joined GWS services 4 years ago and here is my honest review on it. I would like to say that I am in stock market because of “GWS". My total investment in last 4 years is 7 Lacs and I have returns of 21+ Lacs because of GWS. There is no other way, that could have made this kind of return, so I am very thankful to GWS   family. I would like to mention that within 2 years many stocks in my portfolio made huge returns like 3 to 6 times. I am very happy with GWS.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial_card">
                            <div class="row">
                                <div class="col-md-2">
                                    <img src="../assets/gws_gayathri.jpg" alt="Photo of Gayathri Umachandran, Grow With Stocks subscriber" class="img-responsive">
                                    <h5>Gayathri Umachandran</h5>
                                </div>
                                <div class="col-md-10">
                                    <p>
                                       I had started trading a few years back, but mostly did it from random suggestions I got from news channels and through some irregular study. Only in the year 2014, I had made my association with GROW WITH STOCKS and took an annual subscription. I have not repented ever since. They have not only made me richer monetarily but also knowledgeable. The fact that I recommend it to my friends and even mentioned it in my Facebook status, shows my respect for  the GROW WITH STOCKS team.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="cta" id="contact">
            <h2>
                Don't miss out on valuable insights! Join our WhatsApp community today and receive a complimentary stock report
            </h2>
            
            <form v-on:submit.prevent="saveData" class="mt-3">
                <v-text-field
                v-model="name"
                label="Name"
                solo
                size="small"
                autocomplete="name"
                :error-messages="nameErrors"
                required
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                ></v-text-field>

                <!-- <v-text-field
                v-model="phone"
                :error-messages="mobileErrors"
                color="white"
                :counter="10"
                label="Mobile"
                required
                solo
                rounded
                @input="$v.phone.$touch()"
                @blur="$v.phone.$touch()"
                ></v-text-field> -->

                <vue-phone-number-input default-country-code="IN" v-model="phone" required :border-radius="2" :countries-height="20" size="lg" class="input_mobile" label="Mobile" @update="handlePhoneChange"/>
                <button class="cta_btn">{{loading ? 'Saving' : 'Join'}}</button>
            </form>

        </section>
        </main>
        <footer>
            <p>
                Email us at <span> info@growwithstocks.com </span>
            </p>
            <p>
                or
            </p>
            <p>
               For any enquiries call us at <span> +91 9271212131 </span>
            </p>
            <div class="row">
                <div class="col-12 col-md-4 col-md-offset-4">
                     <div class="footer_extra_info">
                <div class="ml-2 my-5">
                    <p  v-if="!readMore" @click="readMore = true"><a>Read more Desclaimer</a></p>
                    <p v-else>
                    <strong>
                        PROPRIETOR GROW WITH STOCKS) GOUTAM SHARMA, Research Analyst
                        <br/>
                        </strong>
                        SEBI (Research Analysts) Regulations 2014, Registration No. INH000001212
                        <br>
                        <br>
                        120, SHASTRI NAGAR, BEHIND RAM MANDIR,
                        JAMMU, Jammu & Kashmir - 180004

                            <br>
                        <strong>
                            Telephone:
                        </strong>
                        +91-9271212131
                        <br>
                        <strong> Email: </strong> info@growwithstocks.com, growwithstocks@gmail.com 
                        <br>
                        <strong>Website:
                        </strong>
                        www.growwithstocks.com
                        <br>

                            <br>
                            <strong>

                            <i>
                                Grievance Officer: Mr Goutam Sharma
                            </i>
                            </strong>
                        <br>
                        Telephone: +91-9271212131 | Email: growwithstocks@gmail.com
                    </p>
                    </div>
                    <!-- <p>

                        <strong>SCORES : <a href="https://scores.sebi.gov.in/">
                            https://scores.sebi.gov.in/
                        </a>
                    </strong>
                    <br>
                    Online Dispute Resolution Portal ("ODR Portal") per SEBI
                    (Alternative Dispute Resolution Mechanism) (Amendment) Regulations, 2023 is available at <a href="https://smartodr.in" target="_blank" rel="noopener noreferrer">
                        https://smartodr.in
                    </a>
                </p> -->
                     <div class="footer_extra_info">
                        
               <p  v-if="readMore">
                <strong>Legal Disclaimer : </strong>
                <br>
                Investment in securities market are subject to market risks. Read all the related documents carefully before investing.
                <br>
                <br>
                Registration granted by SEBI and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.
                <br>
                <br>
                Grow With Stocks, Goutam Sharma bearing Registration No. INH000001212  is an  individual Research Analyst. Information herein should be regarded as a resource only and should be used at one's own risk. This is not an offer to sell or solicitation to buy any securities and  Grow With Stocks, Goutam Sharma will not be liable for any losses incurred or investment(s) made or decisions taken/or not taken based on the information provided herein. Information contained herein does not constitute personalized advice or a personal recommendation or take into account the particular investment objectives, financial situations, or needs of individual subscribers.
                <br>
                <br>
              </p>
            </div>
                </div>
                
            </div>
           

            </div>

           
            <p v-if="readMore">Read 
                <span>
                    <a href="/disclaimer" target="_blank" rel="noopener noreferrer">
                        Disclaimer 
                    </a>
                </span>
            </p>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue'
import { required, maxLength, numeric } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import VuePhoneNumberInput from 'vue-phone-number-input';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);


export default {
    mixins: [validationMixin],
    validations: {
        name: { required },
        phone: { numeric, required, maxLength: maxLength(10) }
    },
    computed: {
      mobileErrors() {
        const errors = [];
        if (!this.$v.phone.$dirty) return errors;
        !this.$v.phone.required && errors.push("Mobile Number is required.");
        !this.$v.phone.maxLength && errors.push("Enter correct Mobile Number.");
        return errors;
      },
      nameErrors() {
        const errors = [];
        if (!this.$v.name.$dirty) return errors;
        !this.$v.name.required && errors.push("Name is required.");
        return errors;
      },
    },
    data() {
        return {
            loading: false,
            name: null,
            phone: null,
            phoneFormatted: null,
            readMore: false,
            stocks: [
                {
                    name: "Acrysil India (400% returns)",
                    slug: "acrysil",
                },
                {
                    name: "Atul Auto (512% returns)",
                    slug: "atul",
                },
                {
                    name: "Cera Sanitaryware (700% returns)",
                    slug: "cera",
                },
                {
                    name: "Finolex cables (180%returns)",
                    slug: "finolex",
                },
                {
                    name: "Amara Raja Batteries (188% returns)",
                    slug: "amara",
                },
                {
                    name: "Astral Poly Technik (453% returns)",
                    slug: "astral",
                },
                {
                    name: "Superhouse (161% returns)",
                    slug: "superhouse",
                },
                {
                    name: "Suprajit Engineering (350% returns)",
                    slug: "suprajit",
                },
                {
                    name: "Gulshan Polyols Ltd. (590% returns)",
                    slug: "gulshan",
                },
            ],
            features:[
                {
                    title: "Guidance on your past portfolio",
                    description:"In case you want to know our opinions & suggestions regarding any particular script in your previous holding, we will try our best to help you out."
                },
                {
                    title: "Market - beating stock recommendations",
                    description:"Expert stock recommendations carefully aimed at multiplying net worth."
                },
                {
                    title: "Hard-hitting and Profit-Yielding stocks",
                    description:"Stocks which are like hidden-gems & poised to grow and can produce 2x, 3x, 5x returns.",
                    note:'*Note: The past performance is not an indicator of future performance.'
                },
                {
                    title: "Complete guide for New Beginners in the world of Stocks",
                    description:"Whether you are a beginner or an experienced investor, you need the right strategy. Therefore, you’ll receive a 10-min personalised strategy call prior to your first stock purchase."
                },
                {
                    title: "Unconventional growth stocks to maximize your returns",
                    description:"Investing into companies which may be small or midsize today but are poised to become big in the near furture is how you beat the market."
                },
                {
                    title: "Recommendations based on thorough research and fundamental analysis",
                    description:"We do the research, we do the fundamental analysis, so that you can simply sit back, invest and fetch returns."
                },
                {
                    title: "Targeting the  long-term returns",
                    description:"Sooner or later, you realise that targeting long term returns is how you actually create wealth in the market and compound your returns. "
                },
                {
                    title: "Clear Buy, Sell and Hold updates",
                    description:"You will receive the necessary timely updates."
                },
            ],
            testimonials:[
                {
                    name :'Jay Shah',
                    slug:'jay',
                    description:'I Joined GWS services 4 years ago and here is my honest review on it. I would like to say that I am in stock market because of “GWS". My total investment in last 4 years is 7 Lacs and I have returns of 21+ Lacs because of GWS. There is no other way, that could have made this kind of return, so I am very thankful to GWS   family. I would like to mention that within 2 years many stocks in my portfolio made huge returns like 3 to 6 times. I am very happy with GWS. '
                },
                {
                    name : 'Gayathri Umachandran ',
                    slug:'gayathri',
                    description: 'I had started trading a few years back, but mostly did it from random suggestions I got from news channels and through some irregular study. Only in the year 2014, I had made my association with GROW WITH STOCKS and took an annual subscription. I have not repented ever since. They have not only made me richer monetarily but also knowledgeable. The fact that I recommend it to my friends and even mentioned it in my Facebook status, shows my respect for  the GROW WITH STOCKS team.'

                }
            ],
        }
    },
    mounted(){
        // When the user scrolls the page, execute myFunction
        window.onscroll = function() {myFunction()};

            // Get the header
            var header = document.getElementById("header");

            // Get the offset position of the navbar
            var sticky = header.offsetTop;

            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function myFunction() {
                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                } else {
                    header.classList.remove("sticky");
                }
        }
    },
    methods:{
        getImgUrl(item) {
            try {
                return require(`../assets/${item}.png`)
            } catch(e){
                console.error(e)
            }
        },
        handlePhoneChange(e){
            this.phoneFormatted = e.formatInternational;
        },
        saveData(){
            this.loading = true;
             const store = new SteinStore(
                    "https://api.steinhq.com/v1/storages/63ea9597d27cdd09f0e35fb4"
                );
                store
                    .append("Sheet1", [
                    {
                        name: this.name,
                        phone: this.phoneFormatted,
                        
                    }
                    ])
                    .then(res => {
                        this.loading = false;
                        window.localStorage.setItem('name', this.name);
                        window.localStorage.setItem('phone', this.phoneFormatted);
                        this.$router.push(`/welcome`);
                    })
                    .catch(err => {
                        this.loading = false;
                         this.$toasted.error(err, {
                            duration: 2000,
                            position: "bottom-right"
                        });
                    });
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600;700;800&family=Nunito:wght@300;400;500;600;700&display=swap');


.returns_landing {
    background: #F2F2F2;
    nav {
        box-shadow: 0px 3px 9px -2px rgba(0,0,0,0.2);
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
             @media screen and (max-width: 768px) {   
                justify-content: center;
             }
            .logo {
                img {
                    width: 250px;
                }
            }
            a {
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 24px;
                line-height: 30px;
                text-transform: uppercase;
                color: #0080FF;
                @media screen and (max-width: 768px) {   
                    text-align: center;
                }
            }
            p {
                display: none;
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 24px;
                line-height: 30px;
                color: #0080FF;
                @media screen and (max-width: 768px) {   
                    text-align: center;
                    font-size: 18px;
                    line-height: 20px;
                }
            }
            .nav_btn{
                color:#fff;
                padding: 5px 20px;
                background: #C33990;
                border: 1px solid #FFFFFF;
                border-radius: 10px;
                font-weight: 700;
                font-size: 18px;
                line-height: 40px;
                @media screen and (max-width: 768px) {   
                    display: none;
                }
            }
        }
    }
    .risk{
        margin: 30px 0;
        color: rgba(0,0,0,0.7)
    }
    .hero{
        margin-top: 40px;
        h1{
            text-align: center;
            text-transform: uppercase;
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 60px;
            line-height: 75px;
            text-align: center;
            text-transform: uppercase;
            color: #0080FF;
            margin-bottom: 80px;
             @media screen and (max-width: 768px) {   
                font-size: 40px;
                line-height: 40px;
            }
        }
        p {
           font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 35px;
            color: #333333;
            width: 100%;
            text-align: center;
        }
    }
    .stocks{
        h2{
            font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 40px;
            text-align: center;
            color: #333333;
            margin: 80px 0 20px 0;
        }

        .text-disclaimer{
            text-align: center;
            font-family: 'Nunito Sans';
            font-size: 10px;
            color: black;
        }

        .stock_card{
            background: #FFFFFF;
            box-shadow: 10px 5px 15px rgba(56, 126, 209, 0.2);
            border-radius: 10px;
            margin-bottom: 70px;
            padding: 20px;
            .img-logo{
                border: none;
                @media screen and (max-width: 768px) {   
                    font-size: 25px;
                    display: block;
                    margin: 0 auto;
                }
            }
            h3{
                font-family: 'Nunito Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 30px;
                line-height: 30px;
                text-align: right;
                color: #387ED1;
                @media screen and (max-width: 768px) {   
                    text-align: center;
                    font-size: 25px;
                }
            }
        }
    }
    .recommendations{
        padding: 50px 0 100px;
        h2{
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 50px;
            color: #387ED1;
            margin-bottom: 30px;
            font-family: 'Nunito';
        }
        h4 {
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 30px;
            color: #387ED1;
            margin-bottom: 30px;
            font-family: 'Nunito';
        }
        span{
            color: #C33990;
        }
        p{
            font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 28px;
            color: #333333;
            margin-bottom: 50px;
        }
        .text-disclaimer{
            font-family: 'Nunito Sans';
            font-size: 10px;
            color: black;
        }

        img{
            @media screen and (max-width: 768px) {   
                width: 100%;
            }
        }
    }
    .features{
        background: #6074CF;
        color: #fff;
        text-align: center;
        margin-bottom: 0;

        .feature_text{
            font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 28px;
            margin: 50px 0 150px;
            color: #fff;
        }
        h3 {
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 28px;
            margin-bottom: 100px;
        }
        .feature_grid{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 50px;
            @media screen and (max-width: 768px) {   
                grid-gap: 10px;
                grid-template-columns: repeat(1, 1fr);
            }
              .feature_card {
                background: #F2F2F2;
                border-radius: 10px;
                padding: 50px;
                @media screen and (max-width: 768px) {   
                    padding: 20px;
                }
                .number{
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 100px;
                    line-height: 75px;
                    color: #387ED1;
                    text-align: left;
                    @media screen and (max-width: 768px) {   
                        font-size: 80px;
                    }
                }
                h4{
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 36px;
                    line-height: 40px;
                    color: #387ED1;
                    text-align: left;
                    @media screen and (max-width: 768px) {   
                        font-size: 26px;
                    }
                }
                p {
                    text-align: left;
                    font-family: 'Nunito Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 25px;
                    color: #387ED1;
                }
                .note{
                    text-align: left;
                    font-family: 'Nunito Sans';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 12px;
                    color: rgba(0,0,0,0.7);

                }
            }
        }
      
    }
    .testimonial_hero{
        font-family: 'Nunito';
        background: linear-gradient(90deg, #6074CF 28.78%, #C33990 72.22%);
        padding: 25px 0 50px;
        // .testimonial_text::before {
        //     content: '';
        //     background: url('../assets/quote2.png') no-repeat;
        //     position: absolute;
        //     top: -10px;
        //     left: -30px;
        //     height: 100%;
        //     width: 100%;
        //      @media screen and (max-width: 768px) {   
        //         top: -22px;
        //         left: 2px;
        //         height: 50%;
        //         width: 50%;
        //     }
        // }
        // .testimonial_text::after {
        //     content: '';
        //     background: url('../assets/quote1.png') no-repeat;
        //     position: absolute;
        //     height: 100%;
        //     width: 100%;
        //     color: #fff;
        //     bottom: -10px;
        //     @media screen and (max-width: 768px) {   
        //         height: 50%;
        //         width: 50%;
        //     }
        // }

        h2{
            color: #fff;
            text-transform: uppercase;
            text-align: center;
            margin-bottom: 50px;
        }
        p {
            font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 22px;
            line-height: 40px;
            color: #FFFFFF;
             @media screen and (max-width: 768px) {   
                 font-size: 20px;
            }
        }
    }
    .testimonials{
        min-height: 100vh;
        display: flex;
        align-items: center;
        font-family: 'Nunito';
        .testimonial_card{
            font-family: 'Nunito';
            background: #FFFFFF;
            box-shadow: 10px 5px 15px rgba(56, 126, 209, 0.2);
            border-radius: 10px;
            padding: 30px 30px 50px 30px;
            margin-bottom: 50px;
            h5{
                margin-top: 25px;
            }
        }
    }
    .cta{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background: linear-gradient(90deg, #6074CF 31.81%, #C33990 71.22%);
        color: #fff;
        min-height: 450px;
        padding: 30px;

        h2{
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 40px;
            text-align: center;
            color: #FFFFFF;
            width: 55%;
            margin-bottom: 40px;
            @media screen and (max-width: 768px) {   
                width: 100%;
                font-size: 30px;
            }
        }
        form{
            max-width: 500px;
            width: 100%;
        }
        
        .cta_btn{
            border: 3px solid #FFFFFF;
            border-radius: 10px;
            padding: 20px 45px;
            font-family: 'Nunito';
            font-size: 20px;
            font-weight: 700;
            margin-top: 40px;
            text-transform: uppercase;
        }
        .cta_btn:hover{
            background: #fff;
            color: #387ED1;
        }
    }
    footer{
        margin: 70px 0;
        text-align: center;
        p{
            font-family: 'Nunito Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;
            color: #000000;
            span, a {
                 color: #387ED1;
            }
        }
        .footer_extra_info{
            p{
                font-size: 11px;
                color: rgba(0,0,0,0.8)
            }
        }
    }
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index:1000;
  background-color: #fff;
  transition: 500ms;
  .logo{
    display: none;
  }
  .header_text{
    display: block !important;
  }
  .header{
    @media screen and (max-width: 768px) {   
        flex-direction: column;
    }
  }
  .nav_btn{ 
    @media screen and (max-width: 768px) {   
        display: flex !important;
        padding: 3px 15px !important;
        background: #C33990;
        border: 1px solid #FFFFFF;
        border-radius: 10px;
        font-weight: 700;
        font-size: 15px !important;
    }
  }
}


#MazPhoneNumberInput >>> .input-tel__input{
    color: black;
}
#MazPhoneNumberInput >>> .input-country-selector{
    color: black;
}

</style>



// WEBPACK FOOTER //
// src/views/Landing.vue